var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyntheticLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000180363221749198033210000018031348966969472388_);fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;}\n\t.st1{fill:#FFFFFF;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000044899005195865462200000009341251504476486316_);fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000085219089304677539060000013016933035015589820_);fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.2,
    y: 7.2,
    width: 85.7,
    height: 85.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105390177346955744580000017152026368301613730_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000105390177346955744580000017152026368301613730_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "    M17.7,33.8c-8.9,8.9-8.9,23.4,0,32.3l16.2,16.2c8.9,8.9,23.4,8.9,32.3,0l16.2-16.2c8.9-8.9,8.9-23.4,0-32.3L66.2,17.7    c-8.9-8.9-23.4-8.9-32.3,0L17.7,33.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,36.5h6.2c0.5,0,0.7,0.3,0.5,0.7L40.4,65.6c-0.1,0.3-0.5,0.5-0.8,0.5h-5.4c-0.3,0-0.6-0.2-0.7-0.5    L23.3,37.2c-0.2-0.4,0-0.7,0.5-0.7H30c0.3,0,0.6,0.1,0.7,0.5L37,56.5L43.2,37C43.3,36.6,43.6,36.5,43.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.3,61.1v4.4c0,0.4-0.3,0.6-0.6,0.6H53.9c-0.4,0-0.6-0.3-0.6-0.6v-5l3.8-3.8c5.7-5.8,8.6-7.9,8.6-10.7    c0-2-1.9-3.3-3.5-3.3c-1.8,0-3,0.6-4.2,1.7c-0.3,0.3-0.6,0.3-0.9,0L53.5,41c-0.3-0.3-0.3-0.6,0-0.9c1.9-2.2,4.9-3.9,8.8-3.9    c5.3,0,10.1,4.1,10.1,9.4c0,4.6-3.8,7.7-9.3,13.4l-1.3,1.4h10C72.1,60.4,72.3,60.7,72.3,61.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyntheticLogo);
export default __webpack_public_path__ + "static/media/syntheticLogo.62dfa9955c47d1e1afd41d1279418c56.svg";
export { ForwardRef as ReactComponent };